/**
 * Created with IntelliJ IDEA.
 * User: jschmidt
 * Date: 15.01.14
 * Time: 17:00
 * To change this template use File | Settings | File Templates.
 */

import { GGSTextFieldSignal } from "./GGSTextFieldSignal";

import MouseEvent = createjs.MouseEvent;
/**
 * Add callback to this signal will add listener for createjs.MouseEvent.MOUSE_WHEEL, then the textfield will get correct wheel event.
 * Make sure the textfield can be hit and mouseEnable  = true
 */
export class ScrollSignal extends GGSTextFieldSignal {
    constructor() {
        super();
        this.mappedEventType = MouseEvent.MOUSE_WHEEL;
    }

    public dispatchTyped(event: MouseEvent): void {
        super.dispatch(event);
    }
}
